module.exports = __webpack_public_path__ + "img/preparation.37f5af97.svg";